module.exports = function(h, row) {
    return row.grades.map(grade => grade.name).join(', ');
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/setting/subsidy/templates/grades.jsx